// extracted by mini-css-extract-plugin
export default {"dynamic-preannotations":"lsf-dynamic-preannotations","dynamic-preannotations__wrapper":"lsf-dynamic-preannotations__wrapper","dynamic-preannotations__action":"lsf-dynamic-preannotations__action","dynamic-preannotations__action_type_accept":"lsf-dynamic-preannotations__action_type_accept","dynamic-preannotations__action_type_reject":"lsf-dynamic-preannotations__action_type_reject","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630375297
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  